<template>
  <div>
    <v-form ref="form">
      <v-container>
        <v-layout wrap>
          <v-flex md5 sm12>
            <v-label> {{ $t("locationsPage.stationEditorTitle") }} </v-label>
            <v-text-field v-model="data.name" append-icon="edit" :label="$t('locationsPage.name')" :rules="[rules.required]" single-line
              hide-details></v-text-field>
          </v-flex>
          <!-- <v-flex md5 sm12>
            <v-label> Enter Radius </v-label>
            <v-text-field
              v-model="data.radius"
              append-icon="edit"
              label="Radius"
              type="number"
              step="0.1"
              :rules="[rules.required, rules.number]"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex md5 sm12>
            <v-label> Ejection Radius </v-label>
            <v-text-field
              v-model="data.ejection_radius"
              append-icon="edit"
              label="Ejection Radius"
              type="number"
              step="1"
              :rules="[rules.required, rules.number]"
              single-line
              hide-details
            ></v-text-field>
          </v-flex> -->
          <v-spacer></v-spacer>
          <v-flex md1>
            <v-btn color="primary" dark class="mb-2" @click="save" :loading="loading">{{ $t("locationsPage.save") }}</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab"> {{ $t("locationsPage.entrancePolygon") }} </v-tab>

      <v-tab-item>
        <div id="map"></div>
      </v-tab-item>
      <v-tab :key="2" ripple active-class="tab"> {{ $t("locationsPage.ejectionPolygon") }} </v-tab>

      <v-tab-item>
        <div id="map2"></div>
      </v-tab-item>
    </v-tabs>

  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import centroid from "@turf/centroid";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

export default {
  name: "LandmarkEditor",
  title() {
    return this.$t("locationsPage.stationEditorTitle");
  },
  data() {
    return {
      mode: "add", // or edit
      id: null,
      map: null,
      map2: null,
      loading: false,
      dialog: false,
      drawComponent: null,
      ejectionDrawComponent: null,
      answer: null,
      center: null,
      marker: null,
      marker2: null,
     // polygon: null,
      active: 0,
      data: {
        name: null,
        // radius: 0.0,
        // ejection_radius: 0,
      },
    };
  },
  mounted() {
    Mapbox.accessToken = this.api.mapBox.accessToken;
    this.center = this.api.mapBox.center;
    this.marker = new Mapbox.Marker({ draggable: true });
    this.marker.setLngLat(this.api.mapBox.center);
    this.marker2 = new Mapbox.Marker({ draggable: true });
    this.marker2.setLngLat(this.api.mapBox.center);
    if (this.$route.params.id !== undefined) {
      this.mode = "edit";
      this.id = this.$route.params.id;
      this.getData();
    } else {
      this.mode = "add";
      this.loadMap();
    }
  },
  methods: {
    inside(point, vs) {
      // ray-casting algorithm based on
      // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

      var x = point[0],
        y = point[1];

      var inside = false;
      for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0],
          yi = vs[i][1];
        var xj = vs[j][0],
          yj = vs[j][1];

        var intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    },
    loadMap() {
      this.map = new Mapbox.Map(
        Object.assign({ container: "map" }, this.api.mapBox, {
          center: this.center,
        })
      );
      this.drawComponent = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
      });

      this.map.addControl(this.drawComponent);
      this.map.on("draw.create", this.updateArea);
      this.map.on("draw.delete", this.updateArea);
      this.map.on("draw.update", this.updateArea);
      //   this.center = this.api.mapBox.center;
      //   this.marker = new Mapbox.Marker({ draggable: true });
      this.marker.addTo(this.map);

      this.map2 = new Mapbox.Map(
        Object.assign({ container: "map2" }, this.api.mapBox, {
          center: this.center,
        })
      );
      this.ejectionDrawComponent = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
      });

      this.map2.addControl(this.ejectionDrawComponent);
      this.map2.on("draw.create", this.updateEjectionArea);
      this.map2.on("draw.delete", this.updateEjectionArea);
      this.map2.on("draw.update", this.updateEjectionArea);
      //   this.center = this.api.mapBox.center;
      //   this.marker2 = new Mapbox.Marker({ draggable: true });
      this.marker2.addTo(this.map2);
    },
    getData() {
      this.axios
        .get(this.api.ACTIONS.LANDMARKS + `/${this.id}`)
        .then(({ data }) => {
          const { name, centroid, polygon,ejection_polygon } = data.data;
          this.marker.setLngLat(centroid.coordinates);
          this.marker2.setLngLat(centroid.coordinates);
          // if (data.data.polygon != null) {
          //   this.polygon = data.data.polygon.coordinates[0];
          // } else {
          //   this.polygon = null;
          // }
          this.loadMap();
          this.data.name = name;
          if (polygon != null) {
            this.drawComponent.add(polygon);
          }
          this.data.name = name;
          if (ejection_polygon != null) {
            this.ejectionDrawComponent.add(ejection_polygon);
          }
          // this.data.radius = parseFloat(data.data.radius);
          // this.data.ejection_radius = parseInt(data.data.ejection_radius);
        });
    },
    updateArea(e) {
      if (e.type === "draw.create") {
        this.drawComponent.deleteAll();
        this.drawComponent.add(e.features[0]);
      }
    },
    updateEjectionArea(e) {
      if (e.type === "draw.create") {
        this.ejectionDrawComponent.deleteAll();
        this.ejectionDrawComponent.add(e.features[0]);
      }
    },
    reset() {
      this.drawComponent.deleteAll();
      this.ejectionDrawComponent.deleteAll();
      this.data.name = null;
    },
    save() {
      if (!this.loading && this.$refs.form.validate()) {
        if (this.drawComponent.getAll().features.length === 0) {
          alert(this.$t("locationsPage.choosePolygon"));
          return;
        }
        this.loading = true;
        this.data.landmark_type = "STATION";
        // this.data.radius = parseFloat(this.data.radius);
        // this.data.ejection_radius = parseInt(this.data.ejection_radius);
        this.data.polygon = this.drawComponent.getAll().features[0] ? this.drawComponent.getAll().features[0].geometry : null;
        this.data.ejection_polygon = this.ejectionDrawComponent.getAll().features[0]? this.ejectionDrawComponent.getAll().features[0].geometry : null;
        const url =
          this.mode === "add"
            ? this.api.ACTIONS.LANDMARKS
            : this.api.ACTIONS.LANDMARKS + "/" + this.id;
        (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
          centroid: {
            type: "Point",
            coordinates: this.marker.getLngLat().toArray(),
          },
          ...this.data,
        })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.saved"), "green");
            this.mode === "add" ? this.reset() : null;
          })
          .catch(() => window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.notSaved"), "red"))
          .finally(() => (this.loading = false));
      }
    },
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("locationsPage.ruleRequired"),
        number: (value) => isFinite(value) || this.$t("locationsPage.ruleNumber"),
      };
    },
  },
  watch: {
    active() {
      console.log(this.map,this.map2)
      setTimeout(() => {
        this.map.resize();
        this.map2.resize();
      }, 100)

    },
  }
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 720px;
}
#map2 {
  width: 100%;
  height: 720px;
}
</style>

<style scoped></style>
